function DropDownIcon(props: any) {
  return (
    <svg {...props} width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2858 10.5715L12.0001 14.8572L7.71436 10.5715"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DropDownIcon;
